import {
  ErrorDialogContext,
  errorHandledSync,
} from "@/shared/context/error-context";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useOneTimePassStates } from "@/features/accounts/payment/scraping/hooks/use-one-time-pass-states";
import { useContext } from "react";
import { OneTimePass } from "@/features/accounts/payment/scraping/services/register-accounts-model";
import { useOneTimePassContext } from "@/features/accounts/payment/scraping/contexts/one-time-pass-context";
import { MoneyLinkWarning } from "@/shared/utils/custom-exception";


export type OtpModalResult = {
  status: "" | "ok" | "next" | "error";
  newOtpInfo?: string;
};

export const useOneTimePass = () => {
  const {
    count,
    oneTimePassList,
    otpInfo: currentOtpInfo,
    setOtpInfo,
  } = useOneTimePassContext();
  const {
    inputPass,
    setInputPass,
    isActiveImageBox,
    setIsActiveImageBox,
    isActiveTextBox,
    setIsActiveTextBox,
    validConfirmButton,
    setIsValidConfirmButton,
  } = useOneTimePassStates();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const onChangeOtpTextBox = (value: string) => {
    setInputPass(value);
  };

  const changeConfirmButtonState = (otpType: string) => {
    if (otpType === "3") {
      // 画像認証の場合は、入力不要でボタン有効化
      setIsValidConfirmButton(true);
      return;
    }
    setIsValidConfirmButton(inputPass !== "");
  };

  // OTP確認するボタン押下
  const onClickOtpConfirm = (
    oneTimePass: OneTimePass
  ): OtpModalResult => {
    loadingCtx.setIsLoading(true);
    try {
      if (!oneTimePass) {
        setError(new MoneyLinkWarning({
          title: "ワンタイムパスワード情報の取得に失敗",
          message: "ワンタイムパスワード情報が存在しません。時間をおいて再度お試しください。",
        }));
        return { status: "error" };
      }
      const type = oneTimePass.type;
      const key = oneTimePass.key;
      const value = inputPass;
      const entry = `{"type":"${type}","key":"${key}","val":"${value}"}`;
      const newOtpInfo = currentOtpInfo ? currentOtpInfo + "," + entry : entry;
      if (oneTimePassList.length >= count + 1) {
        setOtpInfo(newOtpInfo);
        if (oneTimePassList.length >= count + 1) {
          return { status: "next", newOtpInfo };
        }
      }
      // OTP情報よりも入力値の方が多い（存在しない想定）
      return { status: "error" };
    } catch (error) {
      console.log("onClickOtpConfirm:", error);
      return { status: "error" };
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  const resetOtpModal = () => {
    setInputPass("");
    setIsActiveImageBox(false);
    setIsActiveTextBox(false);
    setIsValidConfirmButton(false);
  };

  return {
    inputPass,
    setInputPass,
    isActiveImageBox,
    setIsActiveImageBox,
    isActiveTextBox,
    setIsActiveTextBox,
    validConfirmButton,
    setIsValidConfirmButton,
    onChangeOtpTextBox,
    changeConfirmButtonState,
    onClickOtpConfirm: errorHandledSync(onClickOtpConfirm, setError),
    resetOtpModal,
  };
};
